import React from 'react'

import {BaseDialog, Role} from 'dialogs/BaseDialog'
import ProgressBar from 'common/ProgressBar'
import theme from 'dialogs/Complaint.scss'
import Header from 'common/Header'
import Footer from 'common/Footer'
import Form from './Form'
import FormConfirmation from './FormConfirmation'
import {getMessage as msg} from 'MessageBundle'

export default class ExtendComplaint extends BaseDialog {

    constructor(props) {
        super(props);

        this.initialNumber = this.props.location.state !== undefined ? this.props.location.state.complaintNumber : "";
        this.view = {
            extending: this.showExtendComplaintForm,
            processing: this.showProgressBar,
            confirmation: this.showConfirmationPage
        };

        this.state = {
            view: this.view.extending,
            extendedComplaint: undefined,
        }
    }

    getAllowedRoles() {
        return [Role.ANONYMOUS, Role.SALES_PARTNER, Role.VPQ_OPERATOR];
    }

    componentDidMount() {
        super.init();
    }

    showExtendComplaintForm = () => {
        return (
            <div className={theme.wrap}>
                <Header value={msg('complaintManagement.header')}/>
                <section>
                    <Form vo={this.state.vo} complaintNumber={this.initialNumber} vpqOperator={this.state.vpqOperator}
                        authenticated={this.state.vo !== undefined} onSubmit={this.changeView(this.view.processing)}
                        onComplete={this.changeView(this.view.confirmation)}/>
                </section>
                <Footer />
            </div>
        );
    };

    showProgressBar = () => {
        return <ProgressBar/>;
    };

    showConfirmationPage = () => {
        return (
            <div className={theme.wrap}>
                <Header value={msg('complaintManagement.header')}/>
                <section>
                    <FormConfirmation complaint={this.state.extendedComplaint} authenticated={this.state.vo !== undefined}
                        onStatusLinkClick={() => {this.props.history.push('/status')}}/>
                </section>
                <Footer />
            </div>
        );
    };

    changeView = (view) => (extendedComplaint) => {
        this.setState({
            view: view,
            extendedComplaint: extendedComplaint
        })
    };

    getDialog() {
        return this.state.view();
    }
}


// WEBPACK FOOTER //
// ./src/dialogs/ExtendComplaint/index.js